import type { Filter } from "@/services/collection";
import { type CollectionStatistics, fetchPortfolioStatistics } from "@/services/collection";
import { type OnlyPublicProperties } from "@/types";

export function usePortfolioStats() {
  const stats = ref<CollectionStatistics>();

  const loadStats = async (filter: OnlyPublicProperties<Filter.Filter>) => {
    stats.value = undefined;
    stats.value = await fetchPortfolioStatistics(filter);
  };

  return {
    stats,
    loadStats,
  };
}
